import {Card, Box, Grid, TableContainer, Table, TableCell, TableRow, TableBody, TableHead} from '@material-ui/core';
import {useEffect, useState} from "react";
import {useTranslate} from "react-admin";

import {dashboard} from '../../styles/dashboard';
import axiosForApi from "../../config/axios-for-api";
import CircularProgress from "@material-ui/core/CircularProgress";
import StatHeader from "./StatHeader";

interface StatDataRow {
    month: number;
    month_fmt?: string;
    total_ordered: number;
    total_ordered_fmt: string;
    total_saved: number;
    total_saved_fmt: string;
    total_sent_by_email: number;
    total_sent_by_email_fmt: string;
    revenue:number;
    revenue_fmt:string;
}


function toMonthName(monthNumber: number) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('de-DE', {
        month: 'short',
    });
}

const Loading = ({classes}: any) => {
    return (
        <Card className={classes.card}>
            <Box p={2} display={'flex'} justifyContent={'center'} alignItems={'center'} height={200}>
                <CircularProgress/>
            </Box>
        </Card>
    );
}

const CobThisYear = ({countries, forCatalogOffers = false}: { countries: string[] | null, forCatalogOffers?:boolean }) => {
    const classes = dashboard();
    const translate = useTranslate();

    const [shouldLoadStatsData, setShouldLoadStatsData] = useState(true);

    const [tableData, setTableData] = useState<StatDataRow[]>([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancel = false;
        const loadStatsData = async () => {
            const {data} = await axiosForApi.get(`api/admin/${forCatalogOffers?'catalog-offer-stats':'stats'}/cob-this-year`, {
                params: {
                    countries
                }
            });

            if(!cancel) {

                setLoading(false);
                setShouldLoadStatsData(false);

                const newTableData = [...data ?? []];
                setTableData(newTableData.sort((a: StatDataRow, b: StatDataRow) => b.month - a.month));
            }
        }

        shouldLoadStatsData && loadStatsData();

        return () => {
            cancel = true;
        }
    }, [shouldLoadStatsData, countries, forCatalogOffers]);

    if (loading) return (<Loading classes={classes}/>);

    return (
        <Card className={classes.card}>
            <Box p={2}>
                <StatHeader
                    justifyContent='center'
                    title={translate('resources.admin/dashboard.headers.cob-this-year')}
                    help='resources.admin/dashboard.help.cob-this-year'
                />
                <Grid container spacing={0}>
                    <Grid item xs={12} sm={12}>
                            <TableContainer className={'scrollable'} style={{paddingRight:'1rem', height: '300px', overflowY: 'scroll'}}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{position:'sticky', top:0, backgroundColor:'#fff'}}></TableCell>
                                            <TableCell align="right" style={{position:'sticky', top:0, backgroundColor:'#fff'}}>Saved</TableCell>
                                            <TableCell align="right" style={{position:'sticky', top:0, backgroundColor:'#fff'}}>By Email</TableCell>
                                            <TableCell align="right" style={{position:'sticky', top:0, backgroundColor:'#fff'}}>Ordered</TableCell>
                                            <TableCell align="right" style={{position:'sticky', top:0, backgroundColor:'#fff'}}>Revenue</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableData.map((data, i) => (
                                            <TableRow key={`row_${i + 1}`}>
                                                <TableCell padding={'none'}>
                                                    {toMonthName(data.month)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {data.total_saved_fmt}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {data.total_sent_by_email_fmt}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {data.total_ordered_fmt}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {data.revenue_fmt}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
}

export default CobThisYear;
